import React from 'react';

// Outline bell — "reminder: informational only, no assignee needed". Plain/
// monochrome by design (stroke="currentColor"), not the colorful 🔔 emoji.
export function ReminderIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 8a6 6 0 0 1 12 0c0 4 1.5 6 2 7H4c.5-1 2-3 2-7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 19a2 2 0 0 0 4 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Two-arrow loop — "part of a recurring series" / "manage recurring events".
// Deliberately distinct from the plain single-arrow ↻ glyph used for refresh
// actions elsewhere in the app, so the two concepts never look the same.
export function RecurringIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
      <path d="m17 2 4 4-4 4" />
      <path d="M3 11v-1a4 4 0 0 1 4-4h14" />
      <path d="m7 22-4-4 4-4" />
      <path d="M21 13v1a4 4 0 0 1-4 4H3" />
    </svg>
  );
}

// Two-person handoff glyph — "running late/asking ahead, pass this to someone else"
export function CoverageIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="5" cy="6" r="2.3" fill="currentColor" />
      <path d="M1.5 15c0-2.5 1.6-4 3.5-4s3.5 1.5 3.5 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
      <circle cx="19" cy="6" r="2.3" fill="currentColor" />
      <path d="M15.5 15c0-2.5 1.6-4 3.5-4s3.5 1.5 3.5 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
      <path d="M9 9.5h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M13 7.2 15.5 9.5 13 11.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}
